module.exports = "/_next/static/images/BuildHighPerformance-2-6b4cf4e8c560f46acf91e30d8a531d1c.webp";